import { Link, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ContactUsLinkProps {
    onClick: () => void;
}

export default function ContactUsLink({ onClick }: ContactUsLinkProps) {
    const { t } = useTranslation('auth', { keyPrefix: 'loginHelp.needHelp' });

    return (
        <Root variant="body2">
            { t('haveQuestion') }
            { ' ' }
            <Link
                variant="body2"
                onClick={ onClick }
                underline="always"
            >
                { t('contactUs') }
            </Link>
        </Root>
    );
}

const Root = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    color: theme.palette.text.secondary,

    a: {
        cursor: 'pointer'
    }
}));
